import { SVGProps, Ref, forwardRef } from 'react';

export const SendAndroidFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M17.8 8.022 7.78 3.082C4.19 1.311 2.394.426 1.445 1.404c-.949.98-.283 3.03 1.047 7.129l.248.765L14.622 12l-11.88 2.7-.249.767c-1.33 4.1-1.996 6.15-1.047 7.129s2.744.094 6.333-1.676l10.021-4.94C21.267 14.268 23 13.414 23 12s-1.733-2.27-5.2-3.978"
                fill="currentColor"
            />
        </g>
    </svg>
));
SendAndroidFilledSize24Glyph.displayName = 'SendAndroidFilledSize24Glyph';
